module.exports = __webpack_public_path__ + "img/completion8.f9c7888c.svg";